// extracted by mini-css-extract-plugin
module.exports = {"hero":"hero__2Y9kF","link":"link__3RIdI","section":"section__yR_Ev","c":"c__bCWfR","subtitle":"subtitle__CW2aU","image":"image__DKm0I","buttons":"buttons__2R7qX"};